import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerTwo from "../components/DashBoardLayerTwo";
import DailyReportTableNew from "../components/child/DailyReportTableNew";


const HomePageTwo = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Leads" />

        {/* DashBoardLayerTwo */}
        <DashBoardLayerTwo />
        {/* <DailyReportTableNew /> */}

      </MasterLayout>
    </>
  );
};

export default HomePageTwo;
